var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clapperboard-play-svgrepo-com",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7282",
    "data-name": "Path 7282",
    d: "M2,11C2,6.757,2,4.636,3.318,3.318S6.757,2,11,2s6.364,0,7.682,1.318S20,6.757,20,11s0,6.364-1.318,7.682S15.243,20,11,20s-6.364,0-7.682-1.318S2,15.243,2,11Z",
    fill: "none",
    stroke: "#9facbe",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7283",
    "data-name": "Path 7283",
    d: "M19.6,8H2.5",
    transform: "translate(-0.05 -0.6)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7284",
    "data-name": "Path 7284",
    d: "M10.15,2.5,7,7.45",
    transform: "translate(-0.5 -0.05)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7285",
    "data-name": "Path 7285",
    d: "M16.65,2.5,13.5,7.45",
    transform: "translate(-1.15 -0.05)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7286",
    "data-name": "Path 7286",
    d: "M14.5,14.2c0-.57-.6-.954-1.787-1.723C11.5,11.7,10.9,11.308,10.45,11.594S10,12.653,10,14.2s0,2.32.45,2.606,1.054-.1,2.262-.883C13.9,15.154,14.5,14.77,14.5,14.2Z",
    transform: "translate(-0.8 -0.95)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.5bf1231ddf79535eb42856e1385982d3.svg";
export { ForwardRef as ReactComponent };